import type { AppStrings } from './types.js';

export const fa: AppStrings = {
  // COMMON
  error_title: 'خطا',
  cancel: 'لغو',
  retry: 'تلاش مجدد',
  back_arrow: '← بازگشت',

  // ASK SCREEN
  ask_box_unavailable: 'صندوق در دسترس نیست',
  ask_box_unavailable_desc: 'لینک ممکن است قدیمی باشد یا صاحب صندوق آن را بسته باشد.',
  ask_create_own_box: 'صندوق خودت را بساز',
  ask_sent_title: 'ارسال شد ✅',
  ask_sent_desc: 'سوال ناشناس تو به صاحب صندوق رسید.',
  ask_anonymous_hint: 'سوالت به‌صورت ناشناس ارسال می‌شود.',
  ask_placeholder: 'سوالت را بنویس…',
  ask_send: 'ارسال',
  ask_sending: 'در حال ارسال…',
  ask_error_rate_limit: 'درخواست‌های زیادی — یک دقیقه صبر کن.',
  ask_error_restart: 'لطفاً Mini App را مجدداً راه‌اندازی کن.',
  ask_error_load: 'بارگذاری صندوق ناموفق بود.',
  ask_error_send: 'ارسال سوال ناموفق بود.',
  ask_error_banned: 'تو در این اپ مسدود شدی.',
  ask_banned_appeal_btn: 'اعتراض',
  ask_appeal_sent: 'اعتراض ارسال شد. ما آن را به‌صورت دستی بررسی می‌کنیم.',

  // AGE GATE
  age_gate_title: 'فقط ۱۸+',
  age_gate_desc:
    'داری یک سوال ناشناس ارسال می‌کنی. محترمانه رفتار کن: آزار، تهدید، محتوای جنسی مربوط به کودکان و هر محتوایی که قانون را نقض کند ممنوع است. ناشناس بودن به معنی فرار از مجازات نیست — تخلفات به تیم نظارت گزارش می‌شود. با ارسال سوال تأیید می‌کنی که ۱۸+ هستی و قوانین را می‌پذیری.',
  age_gate_confirm: 'من ۱۸+ هستم — ادامه',

  // INBOX SCREEN
  inbox_title: 'صندوق تو',
  box_link_accordion: 'لینک دعوت',
  inbox_notifications_ask: '🔔 اجازه می‌دهی بات درباره سوال‌های جدید اعلان بفرستد؟',
  inbox_notifications_allow: 'اجازه می‌دهم',
  inbox_notifications_dismiss_label: 'رد کن',
  inbox_box_toggle_disable: 'غیرفعال کردن سوال‌ها',
  inbox_box_toggle_enable: 'فعال کردن سوال‌ها',
  inbox_box_disabled_warning: 'سوال‌ها غیرفعال شده‌اند — هیچ سوال جدیدی پذیرفته نمی‌شود.',
  inbox_share_hint: 'لینک را به اشتراک بگذار تا دوستانت سوال‌های ناشناس بپرسند.',
  inbox_copy: 'کپی',
  inbox_copied: 'کپی شد',
  inbox_copy_error: 'خطا',
  inbox_no_deeplink: 'لینک بعد از استقرار نمایش داده می‌شود.',
  inbox_invite_story: 'دعوت از طریق Story',
  inbox_invite_chat: 'دعوت از طریق چت',
  inbox_card_rendering: 'کارت دعوت هنوز در حال پردازش است.',
  inbox_story_unsupported:
    'Story در این نسخه از Telegram در دسترس نیست. «از طریق چت» را امتحان کن.',
  inbox_story_error: 'باز کردن Story ناموفق بود.',
  inbox_chat_unsupported:
    'اشتراک‌گذاری چت در این نسخه از Telegram در دسترس نیست. کلاینت را به‌روز کن.',
  inbox_chat_error: 'اشتراک‌گذاری ناموفق بود. دوباره امتحان کن.',
  inbox_chat_prepare_error: 'آماده‌سازی دعوت ناموفق بود.',
  inbox_filter_incoming: 'دریافتی',
  inbox_filter_hidden: 'مخفی',
  inbox_filter_blocked: 'مسدود',
  inbox_filter_empty: 'هنوز چیزی اینجا نیست.',
  inbox_acc_unanswered: 'بی‌جواب',
  inbox_acc_answered: 'پاسخ داده شده',
  inbox_acc_hidden: 'مخفی',
  inbox_acc_blocked: 'مسدود',
  inbox_empty: 'هنوز سوالی نیست. لینک بالا را به اشتراک بگذار.',
  inbox_load_more: 'بارگذاری بیشتر',
  inbox_load_more_error: 'بارگذاری صفحه بعدی ناموفق بود.',
  inbox_error_load: 'بارگذاری صندوق ناموفق بود.',
  inbox_rate_limit: 'درخواست‌های زیادی — یک دقیقه صبر کن.',
  inbox_toggle_error: 'تغییر وضعیت صندوق ناموفق بود.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'ناشناس برام بنویس',
  message_placeholder: 'پیامت را بنویس…',
  message_anonymous_hint: 'پیامت به‌صورت ناشناس ارسال می‌شود.',
  message_sent_title: 'ارسال شد ✅',
  message_sent_desc: 'پیام ناشناست تحویل داده شد.',
  message_owner_entry: 'برام بنویس',
  message_share_hint: 'لینک را به اشتراک بگذار تا هر کسی بتواند برات پیام ناشناس بفرستد.',
  message_inbox_open: 'پیام‌های دریافتی',
  message_inbox_title: 'پیام‌ها',
  message_inbox_empty: 'هنوز پیامی نیست. لینکت را بالا به اشتراک بگذار.',

  // ANSWER SCREEN
  answer_title: 'پاسخ به سوال',
  answer_placeholder: 'جوابت را بنویس…',
  answer_submit: 'ارسال',
  answer_submitting: 'در حال ارسال…',
  answer_back: 'بازگشت',
  answer_error_send: 'ارسال جواب ناموفق بود.',

  // SHARE SCREEN
  share_title: 'جواب منتشر شد ✅',
  share_hint: 'کارت را به اشتراک بگذار و سوال‌های بیشتری جمع کن.',
  share_card_rendering_desc:
    'کارت هنوز در حال پردازش است. به سوال‌ها برگرد و کمی بعد دوباره چک کن — می‌توانی آن را در Story یا چت به اشتراک بگذاری.',
  share_card_alt: 'کارت جواب',
  share_story_btn: 'اشتراک‌گذاری در Story',
  share_story_btn_busy: 'در حال باز کردن…',
  share_chat_btn: 'اشتراک‌گذاری در چت',
  share_chat_btn_busy: 'در حال آماده‌سازی…',
  share_back: 'بازگشت به سوال‌ها',
  share_story_unsupported:
    'Story در این نسخه از Telegram در دسترس نیست. «اشتراک‌گذاری در چت» را امتحان کن.',
  share_story_error: 'باز کردن Story ناموفق بود. «اشتراک‌گذاری در چت» را امتحان کن.',
  share_chat_sent: 'پیام ارسال شد.',
  share_chat_unsupported:
    'اشتراک‌گذاری چت در این نسخه از Telegram در دسترس نیست. کلاینت را به‌روز کن.',
  share_chat_error: 'اشتراک‌گذاری ناموفق بود. دوباره امتحان کن.',
  share_chat_prepare_error: 'آماده‌سازی پیام ناموفق بود.',

  // LEADERBOARD SCREEN
  lb_title: 'جدول رتبه‌بندی',
  lb_period_7d: '۷ روز',
  lb_period_30d: '۳۰ روز',
  lb_period_all: 'همه وقت',
  lb_group_label: 'دسته‌بندی',
  lb_group_all: 'همه',
  lb_group_ask: 'بپرس',
  lb_group_rate: 'امتیاز',
  lb_group_confession: 'اعتراف',
  lb_group_guesswho: 'حدس بزن کیه',
  lb_group_message: 'پیام‌ها',
  lb_error: 'بارگذاری جدول رتبه‌بندی ناموفق بود',
  lb_empty: 'هنوز کسی در رتبه‌بندی نیست',
  lb_anon: 'ناشناس',
  lb_load_more: 'بارگذاری بیشتر',
  lb_questions: (n) => `${n} سوال`,
  lb_referrals: (n) => `${n} معرفی`,

  // REWARDS SCREEN
  rw_title: 'جوایز من',
  rw_error: 'بارگذاری جوایز ناموفق بود',
  rw_level: (n) => `سطح ${n}`,
  rw_confirmed_referrals: (n) => `${n} معرفی تأیید شده`,
  rw_next_level_section: (n) => `سطح بعدی — ${n} معرفی`,
  rw_to_level: (level, target) => `تا سطح ${level}: ${target}`,
  rw_max_level: 'به بالاترین سطح رسیدی!',
  rw_badges_section: 'نشان‌ها',
  rw_formats_section: 'فرمت‌های صندوق',

  // QUESTION CARD
  qcard_status_new: 'جدید',
  qcard_status_hidden: 'مخفی',
  qcard_status_answered: 'پاسخ داده شده',
  qcard_moderation_flagged: 'احتیاط: پیام مشکوک',
  qcard_answer_btn: 'پاسخ',
  qcard_answer_send: 'ارسال',
  qcard_share_btn: 'اشتراک‌گذاری',
  qcard_hide_btn: 'مخفی کردن',
  qcard_show_btn: 'نمایش',
  qcard_report_btn: 'گزارش',
  qcard_block_btn: 'مسدود کردن',
  qcard_unblock_btn: 'رفع مسدودیت',
  qcard_report_reason_label: 'دلیل گزارش را انتخاب کن:',
  qcard_reason_spam: 'اسپم',
  qcard_reason_harassment: 'آزار',
  qcard_reason_sexual: 'محتوای جنسی',
  qcard_reason_other: 'سایر',
  qcard_error_hide: 'تغییر وضعیت نمایش ناموفق بود.',
  qcard_error_report: 'ارسال گزارش ناموفق بود.',
  qcard_error_block: 'مسدود کردن فرستنده ناموفق بود.',
  qcard_report_done: 'گزارش ارسال شد — ممنون.',
  qcard_block_done: 'فرستنده مسدود شد.',
  qcard_unblock_done: 'مسدودیت فرستنده برداشته شد.',

  // ERRORS
  err_network: 'اتصال به سرور برقرار نیست. اینترنت را چک کن و دوباره امتحان کن.',
  err_server_unavailable: 'سرور موقتاً در دسترس نیست، بعداً دوباره امتحان کن.',
  err_internal: 'مشکلی از طرف ما پیش آمد. داریم بررسی می‌کنیم — بعداً دوباره امتحان کن.',
  err_bad_request: 'لطفاً اطلاعات واردشده را بررسی کن.',
  err_generic: 'عملیات تکمیل نشد، بعداً دوباره امتحان کن.',
  err_schema: 'خطای داده. اپ را به‌روز کن.',
  share_story_link_premium_note:
    'لینک قابل کلیک در Story نیازمند Telegram Premium است. بدون آن دوستانت می‌توانند تو را پیدا کنند — نام کاربری‌ات روی کارت نشان داده می‌شود.',

  // AUTH ERROR SCREEN
  auth_error_title: 'خطای دسترسی',
  auth_error_desc:
    'احراز هویت ناموفق بود. لطفاً Mini App را ببند و از Telegram دوباره باز کن.',

  // REWARD TOAST
  reward_toast_title: 'جایزه جدید!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'سوال‌ها',
  tab_leaderboard: 'رتبه‌بندی',
  tab_rewards: 'جوایز',
  tab_settings: 'تنظیمات',

  // SETTINGS SCREEN
  settings_title: 'تنظیمات',
  settings_section_general: 'عمومی',
  settings_notifications: 'اعلان سوال‌های جدید',
  settings_notifications_hint: 'بات وقتی کسی سوال بپرسد برایت پیام می‌فرستد.',
  settings_notifications_error: 'ذخیره تنظیم اعلان ناموفق بود.',
  settings_language: 'زبان',
  settings_language_error: 'تغییر زبان ناموفق بود. دوباره امتحان کن.',
  settings_section_about: 'درباره',
  settings_version: 'نسخه',

  // CODE ENTRY
  code_modal_title: 'لینک Story فقط برای Premium',
  code_modal_explain:
    'Telegram لینک قابل کلیک در Story را فقط به مشترکان Premium می‌دهد. به‌جای آن کدت را در Story بنویس — بازدیدکنندگان آن را در اپ تایپ می‌کنند و سوال ناشناس می‌پرسند.',
  code_modal_your_code: 'کد تو',
  code_modal_copy: 'کپی کد',
  code_modal_copied: 'کپی شد',
  code_modal_share_btn: 'اشتراک‌گذاری در Story',
  code_modal_loading: 'در حال دریافت کد…',
  code_modal_error: 'دریافت کد ناموفق بود. بعداً دوباره امتحان کن.',
  ask_code_title: 'کد را وارد کن',
  ask_code_desc:
    'از Story آمدی؟ کد را در آن پیدا کن (مثلاً ۱۲۳۴) و پایین تایپ کن.',
  ask_code_placeholder: 'کد از Story',
  ask_code_find: 'جستجو',
  ask_code_not_found: 'کد پیدا نشد. ارقام را بررسی کن و دوباره امتحان کن.',
  ask_code_invalid: 'کد ۴ رقم است.',
  code_onboarding_header: 'از Story آمدی؟',
  code_onboarding_text: 'کد دوستت را وارد کن تا سوال ناشناس بپرسی.',
  code_onboarding_action: 'وارد کردن کد',
  settings_ask_by_code: 'پرسیدن با کد',
  settings_my_code_title: 'کد Story تو',
  settings_my_code_hint:
    'این کد را در Story بنویس — بازدیدکنندگان آن را تایپ می‌کنند تا سوال ناشناس بپرسند. Telegram لینک قابل کلیک در Story را فقط به مشترکان Premium می‌دهد.',
  settings_my_code_rotate: 'دریافت کد جدید',
  settings_my_code_rotating: 'در حال به‌روزرسانی…',
  settings_my_code_done: 'کد به‌روز شد',
  settings_my_code_error: 'دریافت کد ناموفق بود.',
  settings_my_code_rotate_confirm_title: 'کدت رو عوض کنی؟',
  settings_my_code_rotate_confirm_desc:
    'کد قبلیت همون لحظه از کار می‌افته. هر کسی توی استوری‌ت دیده بودش دیگه نمی‌تونه بهت پیام بده. فقط وقتی عوضش کن که یکی داره اذیتت می‌کنه.',
  settings_my_code_rotate_confirm_action: 'عوض کردن کد',

  // BOT
  bot_greeting: (name) => (name ? `سلام، ${name}! 👋` : 'سلام! 👋'),
  bot_onboarding:
    'این VeylMe است — سوالات ناشناس.\n\n' +
    'Mini App را باز کن، کارت «از من ناشناس بپرس» را در Story خود منتشر کن — ' +
    'و سوالات ناشناس را مستقیم اینجا دریافت کن.\n\n' +
    '⚠️ 18+. محترمانه رفتار کن: آزار، تهدید و محتوای ممنوع ' +
    'مجاز نیست. ناشناس بودن ≠ بی‌مجازاتی — تخلفات به مدیریت گزارش می‌شود.',
  bot_open_btn: 'باز کردن VeylMe',
  notify_answer_btn: 'پاسخ',
  bot_invite_text:
    'کسی لینک VeylMe را به اشتراک گذاشته است.\n\n' +
    'Mini App را باز کن تا سوال ناشناس بپرسی:',
  bot_invite_btn: 'پرسیدن ناشناس',

  // WORK-027 i18n sweep
  tagline: 'ناشناس از من بپرس',
  share_ask_action: 'بپرس',
  share_answered_text: 'به یک سوال ناشناس پاسخ دادم 👀',
  err_not_in_telegram: 'Mini App داخل Telegram اجرا نمی‌شود. لطفاً اپ را دوباره راه‌اندازی کن.',
  badge_viral_starter: 'شروع وایرال',
  badge_storyteller: 'داستان‌سرا',
  badge_loop_master: 'استاد چرخه',
  theme_confession: 'اعتراف‌ها',
  theme_guesswho: 'حدس بزن کیه',
  rw_format_named: (name) => `فرمت «${name}»`,
  card_label_question: 'سوال',
  card_label_answer: 'جواب',
  card_invite_subtitle: 'ناشناس، بدون ثبت‌نام',
  card_code_hint: 'کد را در اپ وارد کن',
  share_msg_title: (brand) => `${brand} · سوالات ناشناس`,
  notify_new_question: '🔔 کسی از شما یک سوال ناشناس پرسید',
  notify_unanswered_reminder: (n) => `🔔 ${n} سوال بی‌پاسخ داری`,
  notify_ban_permanent: 'برای همیشه',
  notify_ban_until: (date) => `تا ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ تو در VeylMe ${untilPhrase} مسدود شدی. تعداد زیادی از گیرندگان پیام‌های تو را گزارش کردند.\nاگر فکر می‌کنی این اشتباه است، می‌توانی در اپ اعتراض ثبت کنی.`,
  notify_warning_msg:
    '⚠️ چند نفر از گیرندگان پیام‌های تو را گزارش کردند. کمی بیشتر و در VeylMe مسدود می‌شوی.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'سوال‌های من',
  my_questions_empty_title: 'هنوز سوالی نپرسیده‌ای',
  my_questions_empty_desc: 'در جعبه یکی سوال بپرس — پاسخ اینجا نمایش داده می‌شود.',
  my_questions_loading: 'در حال بررسی پاسخ…',
  my_questions_waiting: 'در انتظار پاسخ',
  my_questions_answer_label: 'پاسخ',
  settings_my_questions: 'سوال‌های من',
  ask_sent_find_reply_hint: 'می‌توانی بعداً پاسخ را در «سوال‌های من» پیدا کنی.',
  inbox_story_nonpremium_hint: 'لینک استوری بدون Telegram Premium قابل کلیک نیست، پس یک کد نشان می‌دهیم — اشتراک‌گذاری در چت مطمئن‌تر است.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'مجوز Telegram منقضی شده است',
  session_expired_desc: 'Telegram فقط یک بار هنگام اجرا به برنامه مجوز می‌دهد و این مجوز منقضی شده است. برنامه را دوباره باز کن — متنی را که شروع کرده بودی ذخیره کردیم.',
  session_expired_desc_no_storage: 'مجوز Telegram شما منقضی شده و باید برنامه را دوباره باز کنید. نتوانستیم متنی را که نوشتید ذخیره کنیم — پیش از خروج آن را کپی کنید.',
  session_expired_reopen: 'باز کردن دوباره',
  session_expired_stuck_title: 'Telegram همان مجوز قدیمی را برگرداند',
  session_expired_stuck_desc: 'برنامه را از منوی بات کاملاً ببند و دوباره باز کن — آن‌وقت Telegram مجوز تازه‌ای می‌دهد.',
  session_auth_failed_title: 'ورود تأیید نشد',
  session_auth_failed_desc: 'Telegram ورود تو به برنامه را تأیید نکرد. برنامه را ببند و از چت با بات دوباره باز کن.',
  session_expired_manual_close: 'برنامه از اینجا نمی‌تواند خودش را ببندد — خودت آن را ببند و از چت با بات دوباره باز کن.',
  session_expiring_soon: 'مجوز Telegram به‌زودی منقضی می‌شود. برنامه را دوباره باز کن تا چیزی از دست نرود.',
  my_questions_check_failed: 'بررسی پاسخ‌ها ممکن نشد. بعداً دوباره تلاش کن.',
  settings_notifications_load_error: 'بارگذاری تنظیم ممکن نشد.',
};
